import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-referralpopup',
  templateUrl: './referralpopup.component.html',
  styleUrls: ['./referralpopup.component.scss']
})
export class ReferralpopupComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
